import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["assistanceServiceParams"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useContext, useMemo } from 'react';
import { di } from 'react-magnetic-di';
import { fg } from '@atlaskit/platform-feature-flags';
import { useAIMateExperienceTracker } from '@atlassian/conversation-assistant-instrumentation';
import { setRovoChatProduct } from '../../common/utils/product-config';
import { readJsonStream } from './read-json-stream';
import { isHumanMessage } from './types';
import { addPath, getTraceIdFromResponse, processResponse } from './utils/client';
import { generateConversationName } from './utils/conversation';
import { toStreamResponse } from './utils/data';
import { fetchFn } from './utils/fetch';
var PRODUCT_HEADER = 'x-product';
var EXPERIENCE_ID_HEADER = 'x-experience-id';
export var AssistanceServiceBase = /*#__PURE__*/function () {
  function AssistanceServiceBase(props) {
    var _this = this;
    _classCallCheck(this, AssistanceServiceBase);
    _defineProperty(this, "getConfig", function () {
      return _objectSpread({}, _this.config);
    });
    var defaultBaseUrl = '/gateway/api/assist';
    var defaultConfig = {
      baseUrl: defaultBaseUrl,
      headers: {}
    };
    this.config = _objectSpread(_objectSpread({}, props), {}, {
      baseUrl: props.baseUrl || defaultConfig.baseUrl,
      credentials: props.credentials,
      headers: _objectSpread({}, props.headers || defaultConfig.headers)
    });
  }
  return _createClass(AssistanceServiceBase, [{
    key: "createHeaders",
    value: function createHeaders(init) {
      return new Headers(_objectSpread(_objectSpread(_defineProperty(_defineProperty({}, PRODUCT_HEADER, this.config.product), EXPERIENCE_ID_HEADER, this.config.experienceId), this.config.headers || {}), init || {}));
    }
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var path, options, _this$config, configBaseUrl, configCredentials, baseUrl, requestUrl, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              path = _ref.path, options = _ref.options;
              _this$config = this.config, configBaseUrl = _this$config.baseUrl, configCredentials = _this$config.credentials;
              baseUrl = configBaseUrl;
              requestUrl = addPath(baseUrl, path);
              _context.next = 6;
              return fetchFn(requestUrl, _objectSpread({
                credentials: configCredentials
              }, options));
            case 6:
              response = _context.sent;
              return _context.abrupt("return", processResponse({
                response: response
              }));
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
  }, {
    key: "fetchJson",
    value: function () {
      var _fetchJson = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(options) {
        var response, json;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.fetch(options);
            case 2:
              response = _context2.sent;
              _context2.next = 5;
              return response.json();
            case 5:
              json = _context2.sent;
              return _context2.abrupt("return", json);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchJson(_x2) {
        return _fetchJson.apply(this, arguments);
      }
      return fetchJson;
    }()
  }, {
    key: "fetchStream",
    value: function () {
      var _fetchStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(options) {
        var response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.fetch(options);
            case 2:
              response = _context3.sent;
              return _context3.abrupt("return", {
                responseData: {
                  traceId: getTraceIdFromResponse(response)
                },
                generator: readJsonStream(response)
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchStream(_x3) {
        return _fetchStream.apply(this, arguments);
      }
      return fetchStream;
    }()
  }]);
}();
export var AssistanceServiceImpl = /*#__PURE__*/function (_AssistanceServiceBas) {
  function AssistanceServiceImpl(props) {
    var _this2;
    _classCallCheck(this, AssistanceServiceImpl);
    _this2 = _callSuper(this, AssistanceServiceImpl, [props]);
    _defineProperty(_this2, "getAgentActions", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var response;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _this2.fetchJson({
              path: '/rovo/v1/agents/configuration/actions',
              options: {
                method: 'GET',
                headers: _this2.createHeaders()
              }
            });
          case 2:
            response = _context4.sent;
            return _context4.abrupt("return", response.actions);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })));
    _defineProperty(_this2, "getAgentKnowledgeConfiguration", function () {
      return _this2.fetchJson({
        path: '/rovo/v1/agents/configuration/knowledge',
        options: {
          method: 'GET',
          headers: _this2.createHeaders()
        }
      });
    });
    _defineProperty(_this2, "getAgentPermissions", function (agentId, payload) {
      return _this2.fetchJson({
        path: "/rovo/v2/permissions/agents/".concat(agentId),
        options: {
          method: 'POST',
          headers: _this2.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
          }),
          body: JSON.stringify(payload)
        }
      });
    });
    _defineProperty(_this2, "getRecommendedAgents", function (_ref3) {
      var limit = _ref3.limit,
        query = _ref3.query;
      return _this2.fetchJson({
        path: "/rovo/v1/agents/recommend/v2?limit=".concat(limit, "&query=").concat(query),
        options: {
          method: 'GET',
          headers: _this2.createHeaders()
        }
      });
    });
    _defineProperty(_this2, "getConversationDebugLogs", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(conversationId) {
        var response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this2.fetchJson({
                path: "/rovo/v1/chat/conversation/".concat(conversationId, "/debug-logs"),
                options: {
                  method: 'GET',
                  headers: _this2.createHeaders()
                }
              });
            case 2:
              response = _context5.sent;
              return _context5.abrupt("return", response.items);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }());
    _defineProperty(_this2, "validateFiles", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(payload) {
        var headers;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              headers = _this2.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
              });
              return _context6.abrupt("return", _this2.fetchJson({
                path: "/rovo/v1/chat/message/file/validate",
                options: {
                  method: 'POST',
                  headers: headers,
                  body: JSON.stringify(payload)
                }
              }));
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function (_x5) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(_this2, "uploadFiles", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(payload) {
        var formData, _iterator, _step, file, response;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              formData = new FormData();
              _iterator = _createForOfIteratorHelper(payload.files);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  file = _step.value;
                  formData.append('files', file);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _context7.next = 5;
              return _this2.fetchJson({
                path: "/rovo/v1/chat/message/file",
                options: {
                  method: 'POST',
                  headers: _this2.createHeaders(),
                  body: formData
                }
              });
            case 5:
              response = _context7.sent;
              return _context7.abrupt("return", response);
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return function (_x6) {
        return _ref6.apply(this, arguments);
      };
    }());
    return _this2;
  }
  _inherits(AssistanceServiceImpl, _AssistanceServiceBas);
  return _createClass(AssistanceServiceImpl, [{
    key: "sendMessageStream",
    value: function () {
      var _sendMessageStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref7) {
        var _browserContext$conte, _window, _browserContext$conte2, _browserContext$conte3;
        var agentNamedId, agentId, message, conversationId, controller, _ref7$storeMessage, storeMessage, _ref7$citationsEnable, citationsEnabled, editorContext, browserContext, additionalContext, fileIds, webSearchEnabled, deepResearchEnabled, headers, url, body, options;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              agentNamedId = _ref7.agentNamedId, agentId = _ref7.agentId, message = _ref7.message, conversationId = _ref7.conversationId, controller = _ref7.controller, _ref7$storeMessage = _ref7.storeMessage, storeMessage = _ref7$storeMessage === void 0 ? false : _ref7$storeMessage, _ref7$citationsEnable = _ref7.citationsEnabled, citationsEnabled = _ref7$citationsEnable === void 0 ? true : _ref7$citationsEnable, editorContext = _ref7.editorContext, browserContext = _ref7.browserContext, additionalContext = _ref7.additionalContext, fileIds = _ref7.fileIds, webSearchEnabled = _ref7.webSearchEnabled, deepResearchEnabled = _ref7.deepResearchEnabled;
              headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
              }); // If browserContext received and context is undefined, assume we're unable to retrieve the context of the page in focus
              url = browserContext ? (_browserContext$conte = browserContext.context) === null || _browserContext$conte === void 0 ? void 0 : _browserContext$conte.browserUrl : (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.href;
              body = {
                content: message,
                context: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
                  browser_url: url,
                  webSearchEnabled: webSearchEnabled,
                  deepResearchEnabled: deepResearchEnabled
                }, editorContext ? {
                  editor: editorContext
                } : {}), browserContext ? {
                  browser: {
                    htmlBody: (_browserContext$conte2 = browserContext.context) === null || _browserContext$conte2 === void 0 ? void 0 : _browserContext$conte2.htmlBody,
                    canvasText: (_browserContext$conte3 = browserContext.context) === null || _browserContext$conte3 === void 0 ? void 0 : _browserContext$conte3.canvasText
                  }
                } : {}), additionalContext), {}, {
                  fileIds: fileIds
                }),
                recipient_agent_named_id: agentNamedId,
                agent_id: agentId,
                mimeType: typeof message === 'string' ? 'text/markdown' : 'text/adf',
                // don't allow store message if feature flag is off
                store_message: fg('ai_mate_show_store_messages') ? storeMessage : false,
                citations_enabled: citationsEnabled
              };
              options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(body),
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              return _context8.abrupt("return", this.fetchStream({
                path: "/rovo/v1/chat/conversation/".concat(conversationId, "/message/stream"),
                options: options
              }));
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function sendMessageStream(_x7) {
        return _sendMessageStream.apply(this, arguments);
      }
      return sendMessageStream;
    }()
  }, {
    key: "getChat",
    value: function () {
      var _getChat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(conversationId) {
        var headers, options, rawChat, chatArray;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              headers = this.createHeaders();
              options = {
                method: 'GET',
                headers: headers
              };
              _context9.next = 4;
              return this.fetchJson({
                path: "/rovo/v1/chat/conversation/".concat(conversationId, "/messages"),
                options: options
              });
            case 4:
              rawChat = _context9.sent;
              chatArray = rawChat.items;
              return _context9.abrupt("return", chatArray.map(function (message) {
                return (
                  // Must be converted into StreamResponse
                  isHumanMessage(message) ? message : toStreamResponse(message)
                );
              }));
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getChat(_x8) {
        return _getChat.apply(this, arguments);
      }
      return getChat;
    }()
  }, {
    key: "deleteChat",
    value: function () {
      var _deleteChat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(conversationId, controller) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              headers = this.createHeaders();
              options = {
                method: 'DELETE',
                headers: headers,
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              _context10.next = 4;
              return this.fetch({
                path: "/rovo/v1/chat/conversation/".concat(conversationId),
                options: options
              });
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function deleteChat(_x9, _x10) {
        return _deleteChat.apply(this, arguments);
      }
      return deleteChat;
    }()
  }, {
    key: "getAgents",
    value: function () {
      var _getAgents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(controller) {
        var headers, options, response;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              headers = this.createHeaders();
              options = {
                method: 'GET',
                headers: headers,
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              _context11.next = 4;
              return this.fetchJson({
                path: '/rovo/v1/agents',
                options: options
              });
            case 4:
              response = _context11.sent;
              return _context11.abrupt("return", response.items);
            case 6:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function getAgents(_x11) {
        return _getAgents.apply(this, arguments);
      }
      return getAgents;
    }()
  }, {
    key: "getAgentDetails",
    value: function () {
      var _getAgentDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(id, controller) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              headers = this.createHeaders();
              options = {
                method: 'GET',
                headers: headers,
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              return _context12.abrupt("return", this.fetchJson({
                path: "/rovo/v1/agents/".concat(id),
                options: options
              }));
            case 3:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getAgentDetails(_x12, _x13) {
        return _getAgentDetails.apply(this, arguments);
      }
      return getAgentDetails;
    }()
  }, {
    key: "getAgentDetailsByIdentityAccountId",
    value: function () {
      var _getAgentDetailsByIdentityAccountId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(identityAccountId, controller) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              headers = this.createHeaders();
              options = {
                method: 'GET',
                headers: headers,
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              return _context13.abrupt("return", this.fetchJson({
                path: "/rovo/v1/agents/accountid/".concat(identityAccountId),
                options: options
              }));
            case 3:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function getAgentDetailsByIdentityAccountId(_x14, _x15) {
        return _getAgentDetailsByIdentityAccountId.apply(this, arguments);
      }
      return getAgentDetailsByIdentityAccountId;
    }()
  }, {
    key: "createAgent",
    value: function () {
      var _createAgent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(payload, controller) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
              });
              options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload),
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              return _context14.abrupt("return", this.fetchJson({
                path: '/rovo/v1/agents',
                options: options
              }));
            case 3:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function createAgent(_x16, _x17) {
        return _createAgent.apply(this, arguments);
      }
      return createAgent;
    }()
  }, {
    key: "updateAgent",
    value: function () {
      var _updateAgent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(id, payload, controller) {
        var headers, options, response;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
              });
              options = {
                method: 'PUT',
                headers: headers,
                body: JSON.stringify(payload),
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              _context15.next = 4;
              return this.fetchJson({
                path: "/rovo/v1/agents/".concat(id),
                options: options
              });
            case 4:
              response = _context15.sent;
              return _context15.abrupt("return", response);
            case 6:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function updateAgent(_x18, _x19, _x20) {
        return _updateAgent.apply(this, arguments);
      }
      return updateAgent;
    }()
  }, {
    key: "deleteAgent",
    value: function () {
      var _deleteAgent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(id, controller) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              headers = this.createHeaders();
              options = {
                method: 'DELETE',
                headers: headers,
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              return _context16.abrupt("return", this.fetchJson({
                path: "/rovo/v1/agents/".concat(id),
                options: options
              }));
            case 3:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function deleteAgent(_x21, _x22) {
        return _deleteAgent.apply(this, arguments);
      }
      return deleteAgent;
    }()
  }, {
    key: "favouriteAgent",
    value: function () {
      var _favouriteAgent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(id, controller) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              headers = this.createHeaders();
              options = {
                method: 'POST',
                headers: headers,
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              this.fetch({
                path: "/rovo/v1/agents/".concat(id, "/favourite"),
                options: options
              });
            case 3:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function favouriteAgent(_x23, _x24) {
        return _favouriteAgent.apply(this, arguments);
      }
      return favouriteAgent;
    }()
  }, {
    key: "unfavouriteAgent",
    value: function () {
      var _unfavouriteAgent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(id, controller) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              headers = this.createHeaders();
              options = {
                method: 'DELETE',
                headers: headers,
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              this.fetch({
                path: "/rovo/v1/agents/".concat(id, "/favourite"),
                options: options
              });
            case 3:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function unfavouriteAgent(_x25, _x26) {
        return _unfavouriteAgent.apply(this, arguments);
      }
      return unfavouriteAgent;
    }()
  }, {
    key: "createConversationChannel",
    value: function () {
      var _createConversationChannel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(options) {
        var _options$name, _options$dialogues;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt("return", this.fetchJson({
                path: "/rovo/v1/chat/conversation",
                options: {
                  method: 'POST',
                  headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                  }),
                  body: JSON.stringify({
                    name: (_options$name = options === null || options === void 0 ? void 0 : options.name) !== null && _options$name !== void 0 ? _options$name : generateConversationName(),
                    dialogues: (_options$dialogues = options === null || options === void 0 ? void 0 : options.dialogues) !== null && _options$dialogues !== void 0 ? _options$dialogues : undefined
                  })
                }
              }));
            case 1:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function createConversationChannel(_x27) {
        return _createConversationChannel.apply(this, arguments);
      }
      return createConversationChannel;
    }()
  }, {
    key: "getConversationChannels",
    value: function () {
      var _getConversationChannels = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        var result;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return this.fetchJson({
                path: "/rovo/v1/chat/conversations",
                options: {
                  method: 'GET',
                  headers: this.createHeaders()
                }
              });
            case 2:
              result = _context20.sent;
              return _context20.abrupt("return", result.items);
            case 4:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function getConversationChannels() {
        return _getConversationChannels.apply(this, arguments);
      }
      return getConversationChannels;
    }()
  }, {
    key: "updateConversationChannel",
    value: function updateConversationChannel(id, payload) {
      return this.fetchJson({
        path: "/rovo/v1/chat/conversation/".concat(id),
        options: {
          method: 'PUT',
          headers: this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
          }),
          body: JSON.stringify(payload)
        }
      });
    }
  }, {
    key: "resolveConversationAction",
    value: function () {
      var _resolveConversationAction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(id, payload) {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              return _context21.abrupt("return", this.fetchJson({
                path: "/rovo/v1/chat/conversation/".concat(id, "/action"),
                options: {
                  method: 'POST',
                  headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                  }),
                  body: JSON.stringify(_objectSpread(_objectSpread({}, payload), {}, {
                    context: _objectSpread(_objectSpread({}, payload.context), {}, {
                      browser_url: window.location.href
                    })
                  }))
                }
              }));
            case 1:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function resolveConversationAction(_x28, _x29) {
        return _resolveConversationAction.apply(this, arguments);
      }
      return resolveConversationAction;
    }() // REST starters, newer API
  }, {
    key: "generateAgentStarters",
    value: function () {
      var _generateAgentStarters = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(payload) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
              });
              options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload)
              };
              return _context22.abrupt("return", this.fetchJson({
                path: '/rovo/v1/conversation-starters/agent-starter-suggestion',
                options: options
              }));
            case 3:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function generateAgentStarters(_x30) {
        return _generateAgentStarters.apply(this, arguments);
      }
      return generateAgentStarters;
    }() // REST conversation starters, newer API
  }, {
    key: "generateContextualStarters",
    value: function () {
      var _generateContextualStarters = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(payload) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
              });
              options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload)
              };
              return _context23.abrupt("return", this.fetchJson({
                path: '/rovo/v1/conversation-starters/page-contextual',
                options: options
              }));
            case 3:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function generateContextualStarters(_x31) {
        return _generateContextualStarters.apply(this, arguments);
      }
      return generateContextualStarters;
    }()
  }]);
}(AssistanceServiceBase);
var AssistanceServiceContext = /*#__PURE__*/createContext(new AssistanceServiceImpl({
  baseUrl: '',
  product: '',
  experienceId: ''
}));
export var AssistanceServiceProvider = function AssistanceServiceProvider(_ref8) {
  var value = _ref8.value,
    children = _ref8.children;
  return /*#__PURE__*/React.createElement(AssistanceServiceContext.Provider, {
    value: value
  }, children);
};
/**
 * If these props are provided and one of them are populated, they will take precedence over the `AssistanceServiceProvider` with the missing props filled in
 *
 * @deprecated Please use factory function `createHookWithAssistanceService` instead. We had problems where the consumer of this hook are missing the parent context or not passing in all required paramters to call convo-ai. {@link https://hello.atlassian.net/wiki/spaces/AA6/pages/4323250987/RFC-004+Rovo+components+missing+headers+if+called+outside+chat}
 **/
export var useAssistanceService = function useAssistanceService(props) {
  var _props$product, _props$product2, _props$experienceId, _props$headers;
  var service = useContext(AssistanceServiceContext);
  setRovoChatProduct((_props$product = props === null || props === void 0 ? void 0 : props.product) !== null && _props$product !== void 0 ? _props$product : service.getConfig().product);
  if (!props || !props.experienceId && !props.product && !props.headers) {
    return service;
  }
  var product = (_props$product2 = props.product) !== null && _props$product2 !== void 0 ? _props$product2 : service.getConfig().product;
  var experienceId = (_props$experienceId = props.experienceId) !== null && _props$experienceId !== void 0 ? _props$experienceId : service.getConfig().experienceId;
  var headers = (_props$headers = props.headers) !== null && _props$headers !== void 0 ? _props$headers : service.getConfig().headers;
  return new AssistanceServiceImpl(_objectSpread(_objectSpread({}, service.getConfig()), {}, {
    product: product,
    experienceId: experienceId,
    headers: headers
  }));
};
/**
 * Created for https://hello.atlassian.net/wiki/spaces/AA6/pages/4323250987/RFC-004+Rovo+components+missing+headers+if+called+outside+chat
 * many hooks that require `assistanceService`, often are missing parameters that causes convo-ai call to be 400
 * this hook factory is created to ensure that the `assistanceService` is always called with the correct parameters in any of those hooks
 *
 * Input: react hook that will receive extra prop `assistanceServiceInjectedParams`
 * Output: react hook that enforce `assistanceServiceParams` as a required parameter
 *
 * e.g.
 * const useSomething = createHookWithAssistanceService(
 * 	(hookParams: { customProp: string } & AssistanceServiceInjectedParams) => {
 * 		// this inner hook will get `assistanceServiceInjectedParams` as a prop
 * 		const { customProp, assistanceServiceInjectedParams: { assistanceService } } = hookParams;
 * 		return { ... };
 * 	}
 * );
 *
 * now `useSomething` will have `assistanceServiceParams`, as a required param
 * e.g.
 *
 * useSomething({
 * 	customProp: 'value',
 * 	assistanceServiceParams: { product: 'confluence', experienceId: 'ai-mate', ... }
 * });
 */
export var createHookWithAssistanceService = function createHookWithAssistanceService(originalHook) {
  return function (props) {
    var assistanceServiceParams = props.assistanceServiceParams,
      restProps = _objectWithoutProperties(props, _excluded);
    var experienceTracker = useAIMateExperienceTracker({
      touchpointSource: assistanceServiceParams.touchpointSource
    });
    var headers = useMemo(function () {
      return _objectSpread({
        'x-cloudid': props.assistanceServiceParams.siteId
      }, props.assistanceServiceParams.headers);
    }, [props.assistanceServiceParams.siteId, props.assistanceServiceParams.headers]);
    var assistanceService = useMemo(function () {
      return new AssistanceServiceImpl({
        product: assistanceServiceParams.product,
        experienceId: assistanceServiceParams.experienceId,
        headers: headers,
        baseUrl: assistanceServiceParams.baseUrl
      });
    }, [assistanceServiceParams.baseUrl, assistanceServiceParams.experienceId, assistanceServiceParams.product, headers]);
    var result = originalHook(_objectSpread(_objectSpread({}, restProps), {}, {
      assistanceServiceInjectedParams: _objectSpread(_objectSpread({}, assistanceServiceParams), {}, {
        headers: headers,
        experienceTracker: experienceTracker,
        assistanceService: assistanceService
      })
    }));
    return result;
  };
};